import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { EditReservationDto } from 'store/api-slice/hooks'
import { Person, Time, Zone } from 'store/api-slice/types'
import {
    CabanaReservation,
    MemoryCaptureReservation,
    SpaReservation,
    TicketBundleReservation,
    TicketReservation,
    TransportReservation,
} from './types'
import { PRODUCT_TYPE_SPA } from 'constants/app'

export interface Translation {
    key?: Person | Zone | Time
    title?: string
}
interface SelfcareState {
    orderId: string | null
    ticketsBundles: TicketBundleReservation[] | null
    tickets: TicketReservation[] | null
    spa: SpaReservation[] | null
    transport: TransportReservation[] | null
    cabanas: CabanaReservation[] | null
    memoryCapture: MemoryCaptureReservation[] | null
    ticketTranslations: {
        persons?: Translation[] | null
        zones?: Translation[] | null
        tickets?: Translation[] | null
    }
    isRevertLoading: boolean
    hasAccommodation: boolean
    isMarchPromoMode: boolean // TODO: maybe change to smth like 'isMarchPromoSession'
}

const initialState: SelfcareState = {
    orderId: null,
    ticketsBundles: null,
    tickets: null,
    spa: null,
    transport: null,
    cabanas: null,
    memoryCapture: null,
    ticketTranslations: {
        persons: null,
        zones: null,
        tickets: null,
    },
    isRevertLoading: false,
    hasAccommodation: false,
    isMarchPromoMode: false,
}

const selfcareSlice = createSlice({
    name: 'selfcare',
    initialState,
    reducers: {
        setPositions(state, action: PayloadAction<EditReservationDto[]>) {
            const reservations = action.payload

            // TICKETS BUNDLES
            const ticketsBundles =
                (reservations?.filter(
                    (reservation) => reservation.productType === 'bundle'
                ) as TicketBundleReservation[]) || []

            state.ticketsBundles = ticketsBundles

            // TICKETS
            const tickets =
                (reservations?.filter(
                    (reservation) => reservation.productType === 'ticket'
                ) as TicketReservation[]) || []

            state.tickets = tickets

            // SPA
            const spa =
                (reservations?.filter(
                    (reservation) =>
                        reservation.productType === PRODUCT_TYPE_SPA
                ) as SpaReservation[]) || []

            state.spa = spa

            // TRANSPORT
            const transport =
                (reservations?.filter(
                    (reservation) => reservation.productType === 'bus_ticket'
                ) as TransportReservation[]) || []

            state.transport = transport

            // CABANAS
            const cabanas =
                (reservations?.filter(
                    (reservation) => reservation.productType === 'cabana'
                ) as CabanaReservation[]) || []

            state.cabanas = cabanas

            // MEMORY CAPTURE
            const memoryCapture =
                (reservations?.filter(
                    (reservation) =>
                        reservation.productType === 'memory_capture'
                ) as MemoryCaptureReservation[]) || []

            state.memoryCapture = memoryCapture
        },
        setAccomodationInSelfcareCart(state, action) {
            state.hasAccommodation = action.payload
        },
        setOrderId(state, action: PayloadAction<string>) {
            state.orderId = action.payload
        },
        setTicketTranslations(
            state,
            action: PayloadAction<{
                type: 'persons' | 'zones' | 'tickets'
                data?: Translation[] | null
            }>
        ) {
            const { data, type } = action.payload
            state.ticketTranslations[type] = data
        },
        setIsRevertLoading(state, action: PayloadAction<boolean>) {
            state.isRevertLoading = action.payload
        },
        setIsMarchPromoMode(state, action) {
            state.isMarchPromoMode = action.payload
        },
    },
})

export const {
    setPositions,
    setAccomodationInSelfcareCart,
    setOrderId,
    setTicketTranslations,
    setIsRevertLoading,
    setIsMarchPromoMode,
} = selfcareSlice.actions
export default selfcareSlice.reducer
